module.exports = __webpack_public_path__ + "static/media/no-category.6e6aa6da.svg";